// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__f934242d701b63ef72df","cls2":"ResearchInterestTags-cls2__a67be5543f66dee3c483 ResearchInterestTags-cls1__f934242d701b63ef72df"};